import { createContext, useEffect, useState } from "react";

export const PriceContext = createContext(null);

export function PriceProvider({ children }) {
  const [prices, setPrices] = useState([]);

  useEffect(() => {
    async function loadPrices() {
      try {
        const response = await fetch('/api/prices');
        const data = await response.json();   // <-- backend returns JSON
        setPrices(data);
      } catch (err) {
        console.error("Failed to load prices", err);
      }
    }

    loadPrices();
  }, []);

  return (
    <PriceContext.Provider value={prices}>
      {children}
    </PriceContext.Provider>
  );
}
